import React from "react";

export default function Label(props) {

    if(props.children === null){
        return null;
    }

    return (
        <label htmlFor={props.forHtml}>
            {props.children}
        </label>
    );
}
